import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a31d91c6-928d-4105-9cc7-4850ef18f1bb/artifacts/zj9kpzwc_JD%20Design%20Haus%20logo%20in%20grayscale%20%281%29.png";
const NAV_LOGO_URL = "https://customer-assets.emergentagent.com/job_elevated-spaces-1/artifacts/76n1u0yz_ChatGPT%20Image%20Apr%2014%2C%202026%2C%2002_22_20%20PM.png";

const NAV_LINKS = [
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Portfolio", path: "/portfolio" },
  { label: "Journal", path: "/journal" },
  { label: "Contact", path: "/contact" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const navBg = scrolled
    ? "bg-bone/90 backdrop-blur-md border-b border-concrete"
    : "bg-bone/80 backdrop-blur-sm";

  const textColor = "text-onyx";
  const logoFilter = !scrolled && isHome ? "brightness(0) invert(1)" : "none";

  return (
    <>
      <nav
        data-testid="main-navigation"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${navBg}`}
      >
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
          <Link to="/" data-testid="nav-logo" className="flex items-center">
            <img
              src={NAV_LOGO_URL}
              alt="J Design Haus"
              className="h-16 md:h-18 w-auto transition-all duration-300"
              style={{
                filter: "invert(1) contrast(3) brightness(0.4)",
                mixBlendMode: "darken",
              }}
            />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-12">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={`editorial-link text-sm tracking-[0.2em] uppercase font-light ${textColor} transition-colors duration-300 hover:text-taupe`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile toggle */}
          <button
            data-testid="nav-mobile-toggle"
            className={`md:hidden ${textColor}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          data-testid="nav-mobile-menu"
          className="fixed inset-0 z-40 bg-onyx flex flex-col items-center justify-center gap-10"
        >
          <button
            className="absolute top-6 right-6 text-bone"
            onClick={() => setMenuOpen(false)}
          >
            <X size={28} />
          </button>
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="font-serif text-3xl text-bone font-light tracking-tight hover:text-taupe transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
